import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const QualifyingDepositsSection = () => (
  <>
    <SectionHeading>Qualifying Deposits</SectionHeading>

    <ListItem marker="(a)" withBottomMargin>
      {"Unless the applicable Key Terms indicate that a “no purchase necessary” route is available (or such other dispensation is available), participation in any Promotion is subject to You having made the required minimum deposit as may be required from time-to-time into Your Account, once opened, (“Qualifying Deposit”) unless the Key Terms specify that a different Qualifying Deposit amount is required."}
    </ListItem>
  </>
);

export default QualifyingDepositsSection;
